document.addEventListener("DOMContentLoaded", function(e) {

	document.addEventListener('click', function (event) {
		if (event.target.matches('#link_text-256-2160315')) {
			event.preventDefault();
			window.print();
		}
	}, false);

});